export const MULTI_LIVE_MIN_STREAMS = 2;
export const MULTI_LIVE_MAX_STREAMS = 4;
